import { whyUseCards } from '@/mocks/seoContent';

export default function WhyUseSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Why People Use Sugargoo Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            From product discovery to shipping optimization, here is how the Sugargoo Spreadsheet transforms your shopping workflow
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {whyUseCards.map((card) => (
            <div
              key={card.title}
              className="group p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/60 hover:border-accent-200 transition-all duration-300"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-4 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${card.icon} text-lg md:text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2">
                {card.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}